import { API } from "@/lib/api";

const KEY = "brb_sid";
let last = { sig: "", at: 0 };

function sessionId() {
  let id = sessionStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(KEY, id);
  }
  return id;
}

// Anonymous funnel metrics: a random id per browser tab session, no cookies, no personal data.
export function track(event, data = {}) {
  try {
    const sig = `${event}|${window.location.pathname}|${data.step || ""}|${data.label || ""}`;
    if (sig === last.sig && Date.now() - last.at < 1000) return;
    last = { sig, at: Date.now() };
    const first = !sessionStorage.getItem(KEY);
    const body = { session_id: sessionId(), event, path: window.location.pathname, ...data };
    if (first && document.referrer) body.referrer = document.referrer.slice(0, 300);
    fetch(`${API}/public/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), keepalive: true }).catch(() => {});
  } catch {
    // metrics must never break the page
  }
}
